import * as React from "react";

interface Props {
  open: boolean;
  className?: string;
  onChange: (open: boolean) => void;
}

const MenuButton: React.FC<Props> = ({ open, className, onChange }) => (
  <div className={`hover:cursor-pointer flex items-center ${className}`}>
    <button className="text-black w-5 h-5 relative focus:outline-hidden" type="button" onClick={() => onChange(!open)} data-pw="mainMenu">
      <span className="sr-only">Open main menu</span>
      <div className="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <span aria-hidden="true" className={`block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out ${open ? "rotate-45" : "-translate-y-1.5"}`} />
        <span aria-hidden="true" className={`block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out ${open ? "opacity-0" : ""}`} />
        <span aria-hidden="true" className={`block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out ${open ? "-rotate-45" : "translate-y-1.5"}`} />
      </div>
    </button>
  </div>
);

export default MenuButton;
